import { Adapter } from "@app/shared/models/adapter.model";

export interface FieldRange {
  min: number;
  max: number;
  decimals?: number;
}

export interface FieldRules {
  required: boolean;
  regex?: string;
  mask?: string;
  minLength?: number;
  maxLength?: number;
  range?: FieldRange;
}

export interface Field {
  value: boolean | string | number | any[] | Date;
  error: string;
  fieldRules: FieldRules;
}

export interface DropDownItem {
  value: any;
  label: string;
}

export class FieldRule {
  constructor(
    public name: string,
    public required: boolean,
    public regex?: string | RegExp,
    public mask?: string,
    public minLength?: number,
    public maxLength?: number,
    public range?: FieldRange
  ) {}
}

export interface FormDataModel {
  model: any;
  fieldRules: FieldRule[];
}

/**
 * Class: FieldRulesAdapter
 *
 * Adapt data model to extract field rules
 */
export class FieldRulesAdapter implements Adapter<FieldRule[]> {
  adapt(rawData: any[]): FieldRule[] {
    if (!rawData) {
      return null;
    }
    const data = rawData;
    return Object.keys(data)
      .filter((key) => data[key].fieldRules)
      .map(
        (key) =>
          new FieldRule(
            key,
            data[key].fieldRules.required,
            data[key].fieldRules.regex,
            data[key].fieldRules.mask,
            data[key].fieldRules.minLength,
            data[key].fieldRules.maxLength,
            data[key].fieldRules.range
          )
      );
  }
}

/**
 * Class: FormDataModelAdapter
 *
 * Adapt response to a FormDataModel data structure.
 *
 * Data structure defines field rules and data model
 */
export class FormDataModelAdapter implements Adapter<FormDataModel> {
  adapt(rawData: any[]): FormDataModel {
    const fieldRulesAdapter: FieldRulesAdapter = new FieldRulesAdapter();

    if (!rawData) {
      return { model: null, fieldRules: null };
    }

    return { model: rawData, fieldRules: fieldRulesAdapter.adapt(rawData) };
  }
}
